import React from 'react';

class AlertAfterReg extends React.Component {
  render() {
    return (
      <div className="alert alert-info" role="alert">
        Спасибо за регистрацию!<br/><br/>
        При отмене регистрации менее чем за <b>4 суток</b> - <br/>
        Организаторы оставляют за собой право закрыть участнику
        возможность регистрации в турниры без предоплаты.
      </div>
    )
  }
}

export default AlertAfterReg;
